// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M9.55779798,0.153461884 C8.52912379,-0.0511539614 7.47087621,-0.0511539614
			6.44220202,0.153461884 L6.25836747,2.25876711 C5.88270556,2.37306424 5.51823359,
			2.523329 5.17214507,2.70876211 L3.55360176,1.34998501 C2.68158657,1.93266061
			1.93266061,2.68158657 1.34998501,3.55360176 L2.70876211,5.17214507 C2.523329,
			5.51823359 2.37306424,5.88270556 2.25876711,6.25836747 L0.153461884,6.44220202
			C-0.0511539614,7.47087621 -0.0511539614,8.52912379 0.153461884,9.55779798
			L2.25876711,9.74163253 C2.37306424,10.1172944 2.523329,10.4817664 2.70876211,
			10.8278549 L1.34998501,12.4463982 C1.93266061,13.3184134 2.68158657,14.0673394
			3.55360176,14.650015 L5.17214507,13.2912379 C5.51823359,13.476671 5.88270556,13.6269358
			6.25836747,13.7412329 L6.44220202,15.8465381 C7.47087621,16.051154 8.52912379,16.051154
			9.55779798,15.8465381 L9.74163253,13.7412329 C10.1172944,13.6269358 10.4817664,
			13.476671 10.8278549,13.2912379 L12.4463982,14.650015 C13.3184134,14.0673394
			14.0673394,13.3184134 14.650015,12.4463982 L13.2912379,10.8278549 C13.476671,
			10.4817664 13.6269358,10.1172944 13.7412329,9.74163253 L15.8465381,9.55779798
			C16.051154,8.52912379 16.051154,7.47087621 15.8465381,6.44220202 L13.7412329,
			6.25836747 C13.6269358,5.88270556 13.476671,5.51823359 13.2912379,5.17214507
			L14.650015,3.55360176 C14.0673394,2.68158657 13.3184134,1.93266061 12.4463982,
			1.34998501 L10.8278549,2.70876211 C10.4817664,2.523329 10.1172944,2.37306424
			9.74163253,2.25876711 L9.55779798,0.153461884 Z M8,5.39354581 C9.43870517,
			5.39354581 10.6064542,6.56129483 10.6064542,8 C10.6064542,9.43870517 9.43870517,
			10.6064542 8,10.6064542 C6.56129483,10.6064542 5.39354581,9.43870517 5.39354581,8
			C5.39354581,6.56129483 6.56129483,5.39354581 8,5.39354581 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Settings.js